import React, { useState } from 'react'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import TransitionLink, { TransitionState } from 'gatsby-plugin-transition-link'
import { PrismicLink } from 'prismic'

import { BodyCopy } from 'components/ui/Typography'
import OriginalThumbnail from 'components/ui/OriginalThumbnail'
import AspectRatio from 'components/ui/AspectRatio'

import s from './RelatedOriginals.module.scss'
const cn = classNames.bind(s)

const _ = {
  ratio: 2,
}

const Original = ({ original, transitionStatus, scrollbar }) => {
  const [isActive, setIsActive] = useState(false)
  const [current, setCurrent] = useState(false)

  return (
    <article
      className={cn('original', transitionStatus)}
      onMouseEnter={() => setIsActive(true)}
      onMouseLeave={() => setIsActive(false)}
      onClick={(e) => {
        if (scrollbar) {
          const r = e.currentTarget.getBoundingClientRect()
          const offset = -1 * (r.x - window.innerWidth / 2 + r.width / 2)
          scrollbar.scrollTo(scrollbar.offset.x - offset, 0, 700)
        }
        setCurrent(true)
      }}
    >
      <AspectRatio ratio={_.ratio} mediumRatio={_.ratio} desktopRatio={_.ratio}>
        <div className={cn('originalInner', { current })}>
          <TransitionLink
            className={cn('link')}
            to={PrismicLink.url(original)}
            exit={{
              length: 2,
              state: { to: 'PROJECT_PAGE' },
            }}
            entry={{
              delay: 2, // before mounting new page
            }}
            aria-label="project"
          >
            <OriginalThumbnail
              landscapeVideoWEBM={original.landscape_video_webm || null}
              landscapeVideoMP4={original.landscape_video_mp4 || null}
              landscapeImage={original.landscape_image?.url || null}
              alt={original.landscape_image?.alt || original.original?.topic}
              isActive={isActive}
            />
          </TransitionLink>
        </div>
      </AspectRatio>
      <div className={cn('title')}>
        <BodyCopy as="h3">{original.title[0].text}</BodyCopy>
      </div>
    </article>
  )
}

Original.propTypes = {
  original: PropTypes.object,
  transitionStatus: PropTypes.string,
  scrollbar: PropTypes.object, // scrollbar instance
}

const RelatedOriginals = ({ data, ...props }) => {
  return (
    <TransitionState>
      {({ mount, transitionStatus, current } = {}) => {
        return (
          <div className={cn('wrapper')}>
            {data
              .filter((item) => !!item.project)
              .map((item, i) => (
                <Original original={item.project} key={i} transitionStatus={transitionStatus} {...props} />
              ))}
          </div>
        )
      }}
    </TransitionState>
  )
}

RelatedOriginals.propTypes = {
  data: PropTypes.array,
}

export default RelatedOriginals
